import React from "react"
import { Loader, } from "@bdfx/mergado-ui-kit"

interface Props {
    title?: string | JSX.Element
    style?: any
    className?: string
    children?: any
}

export const SectionLoader = ({ title, style, className, children }: Props) => {
    return (
        <Loader type="section" style={style} className={className} title={title}>
            {children}
        </Loader>
    )
}

export default SectionLoader
